import { IHisInformationItemDefaultSelectBehaviorSpecifiable, IHisInformationItemDefaultSelectBehavior, HisInformationItemDefaultSelectKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanHisItemSelectable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class HisInformationItemDefaultSelectBehaviorTranslator {
  from(bean: IObjectBeanHisItemSelectable): IHisInformationItemDefaultSelectBehavior {
    const kind = this.separator.from(bean["@initial"]);
    const isEnable = (kind !== HisInformationItemDefaultSelectKinds.None);
    return {
      isEnable,
      kind: isEnable ? kind : HisInformationItemDefaultSelectKinds.Top,
    };
  }

  to(object: IHisInformationItemDefaultSelectBehaviorSpecifiable) {
    return {
      initial: object.hisInformationItemDefaultSelectBehavior.isEnable
        ? this.separator.to(object.hisInformationItemDefaultSelectBehavior.kind)
        : undefined,
    };
  }

  private readonly separator = new MapTranslator<HisInformationItemDefaultSelectKinds, string>([
    { object: HisInformationItemDefaultSelectKinds.Top,         bean: "1" },
    { object: HisInformationItemDefaultSelectKinds.CreatedDate, bean: "2" },
    { object: HisInformationItemDefaultSelectKinds.Bottom,      bean: "3" },
  ], HisInformationItemDefaultSelectKinds.None, undefined);
}
